<main>
  <h2>How it works</h2>
  <h3>Peer to peer tech with an open protocol architecture.</h3>
  <div class="card howitworks-screenshot" />
</main>
